import Icon from '@Components/generic/icon';
import getMetricIcon from '@Containers/app/stat-cards/tooltips/get-metric-icon';
import { AppContext } from '@Context/common/general/context';
import useI18n from "@i18n";
import { Stack, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';

const DecisionTooltip = (props: any) => {
    const theme = useTheme();
    const { state, dispatch } = useContext(AppContext);
    const isMobile = state.device.isMobile;
    const { i18n } = useI18n();
    return (
      <Stack
        spacing={2}
        sx={{
          paddingTop: theme.spacing(2),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
          paddingBottom: theme.spacing(2.5),
          backgroundColor: theme.palette.dsNeutral.v400,
          width: isMobile ? `${theme.spacing(25)}` : `${theme.spacing(40)}`,
          maxWidth: isMobile ? `${theme.spacing(25)}` : `${theme.spacing(50)}`,
          borderRadius: "4px",
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            whiteSpace: "nowrap",
            color: "common.white",
          }}
          spacing={1}
        >
          <Icon
            icon={getMetricIcon("DECISION")}
            sx={{
              fontSize: theme.spacing(3),
              color: "inherit",
            }}
          />
          <Typography
            variant="body1"
            sx={{
              fontSize: theme.spacing(2.375),
              fontFamily: "Optician-Sans",
              color: "common.white",
            }}
          >
            {i18n("metric.decision.name")}
          </Typography>
        </Stack>

        <Typography variant="textBase500" sx={{ color: "common.white" }}>
          {i18n("tooltip.decision.description")}
        </Typography>

        <Stack spacing={0.1}>
          <Typography variant="textBase600" sx={{ color: "common.white" }}>
            {i18n("tooltip.decision.how_measured")}
          </Typography>
          <Typography variant="textBase500" sx={{ color: "common.white" }}>
            <span style={{ color: theme.palette.dsPrimary.v300 }}>
              {i18n("tooltip.decision.score_explanation.unit")} -{" "}
            </span>
            {i18n("tooltip.decision.score_explanation")}
          </Typography>
        </Stack>

        <Typography
          sx={{
            fontStyle: "italic",
            fontSize: theme.spacing(1.75),
            color: theme.palette.dsSecondaryYellow.v300,
            fontWeight: 400,
          }}
        >
          {i18n("tooltip.decision.tip")}
        </Typography>
      </Stack>
    );
}

export default DecisionTooltip;